import request from '@/utils/request'

/**
 * 查询工具元件
 * @param {Object} params
 * @returns
 */
export function listToolModelDefinition(params) {
  return request({
    url: '/model_definition/tool_definition/list',
    method: 'GET',
    params
  })
}

/**
 * 添加工具元件
 * @param {Object} data
 * @returns
 */
export function addToolModelDefinition(data) {
  return request({
    url: '/model_definition/tool_definition/insert',
    method: 'POST',
    data
  })
}

/**
 * 修改工具元件
 * @param {Object} data
 * @returns
 */
export function updateToolModelDefinition(data) {
  return request({
    url: '/model_definition/tool_definition/update',
    method: 'POST',
    data
  })
}

/**
 * 删除
 * @param {Object} data
 * @returns
 */
export function removeToolModelDefinition(data) {
  return request({
    url: '/model_definition/tool_definition/remove',
    method: 'POST',
    data
  })
}

/**
 * 添加工具元件
 * @param {Object} data
 * @returns
 */
export function getToolModelDefinitionById(data) {
  return request({
    url: '/model_definition/tool_definition/getById',
    method: 'get',
    data
  })
}
